import { playerInactiveTemplate } from '../Display/DisplayTemplate';

/**
 * Display a message if a player has been soft deleted or facility is inactive.
 */
export async function createInactiveDisplay(
    facilityStatus: string,
    selector: string
): Promise<void> {
    //player has been soft deleted or facility is inactive
    let messageTitle = 'This player is inactive.';
    let messageContent =
        "Please contact Reach support at 952-944-7727 Option 4, or submit a ticket by logging in to 'https://build.reachcm.com'.";

    switch (facilityStatus) {
        case 'cancelled':
            messageTitle = 'This account is inactive';
            messageContent =
                'Please contact REACH support at 952.944.7727 option 4, or submit a ticket by logging into http://build.reachcm.com';
            break;
        case 'on_hold':
            messageTitle = 'Per your request, this account has been put on hold';
            messageContent =
                'To reactivate, please email AR@reachmedianetwork.com or call directly at 952.255.6251';
            break;
    }

    const hbHtml = playerInactiveTemplate({
        messageTitle,
        messageContent,
    });

    $(selector).prepend(hbHtml);
}
